import React from "react";
import { useTranslation } from "react-i18next";
import { TextField, makeValidate } from "mui-rff";
import { Form } from "react-final-form";
import {
  Button,
  LinearProgress,
  Paper,
  Grid,
  Typography,
} from "@material-ui/core";

import * as Yup from "yup";

export default function LoginForm({ classes, onLoginSubmit, loader, error }) {
  const { t } = useTranslation();

  const formFields = [
    {
      size: 12,
      field: (
        <TextField
          type="email"
          label={t('authentication.Login.form.email')}
          name="email"
          margin="none"
          required={true}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          type="password"
          label={t('authentication.Login.form.password')}
          name="password"
          margin="none"
          required={true}
        />
      ),
    },
  ];

  const schema = Yup.object().shape({
    email: Yup.string().email(t('authentication.Login.form.invalidEmail')).required(t('authentication.Login.form.requiredEmail')),
    password: Yup.string().required(t('authentication.Login.form.requiredPassword')),
  });
  const validate = makeValidate(schema);

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Paper square className={classes.paper}>
          <Form
            onSubmit={onLoginSubmit}
            initialValues={{}}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} noValidate>
                <Typography
                  variant="h4"
                  align="left"
                  component="h1"
                  gutterBottom
                >
                  Login
                </Typography>
                <Grid container alignItems="flex-start" justify="flex-end" spacing={2}>
                  {formFields.map((item, idx) => (
                    <Grid item xs={item.size} key={idx}>
                      {item.field}
                    </Grid>
                  ))}
                  <Grid item xs={12}>
                  {error && <div className={classes.error}>{t('authentication.Login.form.' + error)}</div>}
                  </Grid>
                  <Grid item style={{ marginTop: 16 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={submitting || !!loader}
                    >
                      {t('authentication.Login.form.submit')}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          />
        
        {loader && <LinearProgress className={classes.loader} />}
      </Paper>
    </Grid>
  );
}
